import submoduleBreadcrumbs from 'Modules/contacard/communication/subModuleBreadcrumbs';
import { buildCrudRoutes } from 'Arch/components/crud/CrudRouter';

const featureBreadcrumb = [
  ...submoduleBreadcrumbs,
  {
    text: 'Relatório de uso',
    disabled: true,
  },
];

export default [
  ...buildCrudRoutes({
    basePath: 'usage-report',
    baseName: 'contacard.communication.usage-report',
    moduleActive: 'contacard',
    subModuleActive: 'communication',
    baseBreadcrumbs: featureBreadcrumb,
    card: {
      title: 'Relatório de uso',
      icon: 'message-text-clock',
    },
    listRoute: {
      filterComponent: () => import('Modules/contacard/communication/usage-report/UsageReportFilter.vue'),
      navigateBackRoute: 'contacard.submodules.list',
      pageContent: () => import('Modules/contacard/communication/usage-report/UsageReportCrudList.vue'),
      pageTitle: 'Relatório de uso',
      searchComponent: () => true,
    },
  }),
];
